import type { CSSProperties } from "react";

export const MONITOR_DISPLAY_ROTATION_STORAGE_KEY =
  "cf-feed-monitor-display-rotation:v1";

export type MonitorDisplayRotation = 0 | 90 | 180 | 270;

const ROTATIONS: MonitorDisplayRotation[] = [0, 90, 180, 270];

export function parseMonitorDisplayRotation(
  value: unknown,
): MonitorDisplayRotation {
  const parsed =
    typeof value === "string"
      ? Number.parseInt(value, 10)
      : typeof value === "number"
        ? value
        : 0;
  return ROTATIONS.includes(parsed as MonitorDisplayRotation)
    ? (parsed as MonitorDisplayRotation)
    : 0;
}

export function nextMonitorDisplayRotation(
  current: MonitorDisplayRotation,
): MonitorDisplayRotation {
  const index = ROTATIONS.indexOf(current);
  return ROTATIONS[(index + 1) % ROTATIONS.length] ?? 0;
}

export function readStoredMonitorDisplayRotation(): MonitorDisplayRotation {
  try {
    const raw = localStorage.getItem(MONITOR_DISPLAY_ROTATION_STORAGE_KEY);
    if (!raw) return 0;
    return parseMonitorDisplayRotation(raw);
  } catch {
    return 0;
  }
}

export function writeStoredMonitorDisplayRotation(
  rotation: MonitorDisplayRotation,
): void {
  try {
    localStorage.setItem(MONITOR_DISPLAY_ROTATION_STORAGE_KEY, String(rotation));
  } catch {
    // private browsing / storage disabled
  }
}

export function isMonitorDisplaySideways(
  rotation: MonitorDisplayRotation,
): boolean {
  return rotation === 90 || rotation === 270;
}

/** ห่อเนื้อหาเมื่อหมุนจอ — 90/270 สลับ viewport ให้เต็มจอ */
export function getMonitorDisplayRotationShellStyle(
  rotation: MonitorDisplayRotation,
): CSSProperties {
  const sideways = isMonitorDisplaySideways(rotation);
  return {
    position: "fixed",
    top: "50%",
    left: "50%",
    width: sideways ? "100vh" : "100vw",
    height: sideways ? "100vw" : "100vh",
    maxWidth: sideways ? "100vh" : "100vw",
    maxHeight: sideways ? "100vw" : "100vh",
    transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
    transformOrigin: "center center",
    overflow: "auto",
    boxSizing: "border-box",
    minWidth: 0,
  };
}
